





























import Vue from 'vue'
//@ts-ignore
import Swiper from 'swiper/dist/js/swiper.min.js'
import { SWIPER_CONFIG } from '@/top/config/const'
import BaseImage from '@/common/components/BaseImage.vue'
import { IMAGE_VARIANT } from '@/common/const'

interface Carousel {
  image_url: string
  destination_url: string
  alt_text: string
}

export default Vue.extend({
  name: 'TopPageCarousels',
  components: {
    BaseImage
  },
  props: {
    carouselContents: {
      type: Array as () => Array<Carousel>,
      required: true
    }
  },
  data() {
    return {
      swiper: undefined
    }
  },
  computed: {
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.WEB_CAROUSEL
    }
  },
  mounted() {
    this.swiper = new Swiper('.swiper-container', SWIPER_CONFIG)
  }
})
